import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { FormControl, NG_VALUE_ACCESSOR } from '@angular/forms';
import { DateAdapter, MatDateFormats} from '@angular/material/core';
import { MatDatepicker } from '@angular/material/datepicker';
import { Moment } from 'moment';
const INTL_DATE_INPUT_FORMAT = {
  year: 'numeric',
  month: 'numeric',
  day: 'numeric',
}
export const MY_DATE_FORMATS:MatDateFormats = {
  parse: {
    dateInput: INTL_DATE_INPUT_FORMAT,
  },
  display: {
    dateInput: INTL_DATE_INPUT_FORMAT,
    monthYearLabel: { year: 'numeric', month: 'short' },
    dateA11yLabel: { year: 'numeric', month: 'long', day: 'numeric' },
    monthYearA11yLabel: { year: 'numeric', month: 'long' },
  },
};

@Component({
    selector: 'app-calendar-picker',
    templateUrl: './calendar-picker.component.html',
    styleUrls: ['./calendar-picker.component.scss'],
    providers: [],
    standalone: false
})
export class CalendarPickerComponent implements OnInit {

  @ViewChild(MatDatepicker, { static: false }) picker: MatDatepicker<Date> | undefined;

  @Input() label: string = 'choose a date'
  @Input() disabled: boolean = false
  @Input() form?:FormControl<Date|null>

  private _originalValue: Date | null = null
  public tempFormControl!: FormControl<Date | null|undefined>
  constructor(private readonly adapter: DateAdapter<Moment>,) {
    this.adapter.setLocale("it-IT")
  }

  ngOnInit(): void {
    this.tempFormControl=new FormControl(this.form?.value);
    this._originalValue = this.form?.value??new Date()
    this.tempFormControl.valueChanges.subscribe((value)=>{
      this.updateForm(value)
    })
  }

  clearDate() {
    this.form!.setValue(null);
    this.form!.markAsDirty();
  }

  resetField() {
    this.form!.setValue(this._originalValue);
    this.form!.markAsPristine();
  }
  updateForm(date:any){
    if (typeof (date) == "string") {
      date = new Date(date)
    }
    if(date?._d) //il date-picker ritorna la Date in _d
        date=date._d
    if(!date)return ;
    this.form?.markAsDirty()
    this.form?.setValue(date)
  }
}
